import { z } from 'zod';
import { createRESTContract } from '../../index';
import { SuggestionBoxSendSchema } from './suggestion-box.schema';

export const suggestionBoxContract = createRESTContract({
  sendSuggestionBoxEmail: {
    method: 'POST',
    path: '/suggestion-box/email',
    permissions: [],
    body: SuggestionBoxSendSchema,
    response: z.void(),
  },
});
